import {
  EmailVerificationRequest,
  EmailVerificationResponse,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  ResetPasswordConfirmRequest,
  ResetPasswordConfirmResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from "@/redux/authentication/types";
import { BuilderType } from "@/redux/types";

const authenticationService = (builder: BuilderType) => ({
  login: builder.mutation<LoginResponse, LoginRequest>({
    query: (data) => ({
      url: "/auth/login/",
      method: "POST",
      data,
    }),
  }),
  register: builder.mutation<RegisterResponse, RegisterRequest>({
    query: (data) => ({
      url: "/auth/register/",
      method: "POST",
      data,
    }),
  }),
  resetPassword: builder.mutation<ResetPasswordResponse, ResetPasswordRequest>({
    query: (data) => ({
      url: "/auth/password/reset/",
      method: "POST",
      data,
    }),
  }),
  resetPasswordConfirm: builder.mutation<
    ResetPasswordConfirmResponse,
    ResetPasswordConfirmRequest
  >({
    query: (data) => ({
      url: "/auth/password/reset/confirm/",
      method: "POST",
      data,
    }),
  }),
  verifyEmail: builder.mutation<
    EmailVerificationResponse,
    EmailVerificationRequest
  >({
    query: (data) => ({
      url: "/auth/email-verification/",
      method: "POST",
      data,
    }),
  }),
  verifyEmailResend: builder.mutation<
    EmailVerificationResponse,
    EmailVerificationRequest
  >({
    query: (data) => ({
      url: "/auth/email-verification/resend/",
      method: "POST",
      data,
    }),
  }),
  logOut: builder.mutation<null, null>({
    query: () => ({
      url: "/auth/logout/",
      method: "POST",
    }),
  }),
});

export default authenticationService;
